<template>
  <div>
    <v-form-group class="pl-0 pr-0">
      <v-form-select
        v-model="selectedPriceType"
        :options="options"
        class="price-type-class"
        @change="priceTypeChange"
        @keydown.native.tab="onTabNavigation"
        :aria-label="i18n(selectedPriceType)"
      />
    </v-form-group>
  </div>
</template>

<script>
export default {
  name: 'price-type-editor',
  data() {
    return {
      selectedPriceType: null
    };
  },
  computed: {
    options() {
      return this.createOptions();
    }
  },
  methods: {
    i18n(priceType) {
      return this.$t('white-label.widgets.orderEntry.priceTypes.' + priceType);
    },
    getValue() {
      return this.selectedPriceType;
    },
    priceTypeChange() {
      let isMlo = this.params.data.strategy === 'MLO';
      let extendedTerms = isMlo ? this.params.data.multilegEntry.extendedTerms : this.params.data.extendedTerms;
      let durationChanged = false;
      if (this.selectedPriceType === 'MARKET' && extendedTerms.goodTill === 'CANCEL') {
        extendedTerms.goodTill = 'DAY';
        this.params.data.duration = 'DAY';
        durationChanged = true;
      } else {
        if (['LIMIT', 'STOP_LIMIT', 'NET_CREDIT', 'NET_LIMIT'].includes(this.selectedPriceType)) {
          extendedTerms.limitPrice = extendedTerms.limitPrice || 0.0;
        } else if (this.selectedPriceType === 'TRAILING_STOP_LIMIT') {
          extendedTerms.trailingStopTerms.limitDelta = extendedTerms.trailingStopTerms.limitDelta || 0.0;
        }
      }
      if (isMlo) {
        this.params.data.pricePlan = this.selectedPriceType;
        this.params.data.multilegEntry.extendedTerms = extendedTerms;
      } else {
        extendedTerms.orderType = this.selectedPriceType;
        this.params.data.extendedTerms = extendedTerms;
      }
      this.params.context.triggerInlineEditChange(this.params, this.selectedPriceType, durationChanged);
    },
    createOptions() {
      const orderData = this.params.data;
      const isNotional = orderData.isNotional;
      const isFractional = orderData.quantity ? !Number.isInteger(orderData.quantity) : false;
      let pricePlan = '';
      let isMLO = orderData.strategy === 'MLO';
      let duration = '';
      if (isMLO) {
        pricePlan = orderData.pricePlan;
      } else {
        duration = orderData.extendedTerms.goodTill;
        pricePlan = orderData.extendedTerms.orderType;
      }

      let optionsArr = [];

      switch (pricePlan) {
        case 'MARKET':
          optionsArr.push({ value: 'MARKET', text: this.i18n('market'), selected: true });
          if (isMLO) {
            optionsArr.push({ value: 'NET_CREDIT', text: this.i18n('netCredit') });
            optionsArr.push({ value: 'NET_DEBIT', text: this.i18n('netDebit') });
            optionsArr.push({ value: 'EVEN', text: this.i18n('even') });
          } else {
            if (!(isNotional || isFractional)) {
              optionsArr.push({ value: 'LIMIT', text: this.i18n('limit') });
            }
          }
          break;
        case 'LIMIT':
          if (duration !== 'EXTENDED_MARKET')
            optionsArr.push({ value: 'MARKET', text: this.i18n('market'), selected: true });
          optionsArr.push({ value: 'LIMIT', text: this.i18n('limit'), selected: true });
          break;
        case 'STOP_MARKET':
        case 'STOP_LIMIT':
          optionsArr.push({ value: 'STOP_MARKET', text: this.i18n('stopMarket'), selected: true });
          optionsArr.push({ value: 'STOP_LIMIT', text: this.i18n('stopLimit') });
          break;
        case 'TRAILING_STOP_MARKET':
        case 'TRAILING_STOP_LIMIT':
          optionsArr.push({ value: 'TRAILING_STOP_MARKET', text: this.i18n('trailingStopMarket'), selected: true });
          optionsArr.push({ value: 'TRAILING_STOP_LIMIT', text: this.i18n('trailingStopLimit') });
          break;
        case 'NET_DEBIT':
        case 'NET_CREDIT':
        case 'EVEN':
          optionsArr.push({ value: 'MARKET', text: this.i18n('market'), selected: true });
          optionsArr.push({ value: 'NET_CREDIT', text: this.i18n('netCredit') });
          optionsArr.push({ value: 'NET_DEBIT', text: this.i18n('netDebit') });
          optionsArr.push({ value: 'EVEN', text: this.i18n('even') });
          break;
      }
      return optionsArr;
    },
    onTabNavigation(event) {
      this.params.api.stopEditing();
      if (event.shiftKey) this.params.api.tabToPreviousCell();
      else this.params.api.tabToNextCell();
    }
  },
  mounted() {
    const priceTypeModified = this.params.data.pricePlan || this.params.data.extendedTerms.orderType;
    this.selectedPriceType = this.options.find(ele => ele.value === priceTypeModified).value;
  }
};
</script>

<style scoped>
.price-type-class {
  height: 21px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.price-type-div {
  padding-top: 0px;
  padding-bottom: 0px;
  position: relative;
  bottom: 2px;
}
</style>
